var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeasonAutumn = function SvgSeasonAutumn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.582 20.754s1.22 2.495 3.27 2.308c4.158-.38 3.88-5.907 5.4-7.859a9.1 9.1 0 0 0-8.265.075c-2.154 1.222-2.306 3.27-.405 5.476m2.941-2.535s-2.7.335-4.623 5.031m7.126-11.759a10.7 10.7 0 0 0 .911-4.849.48.48 0 0 0-.449-.455 8.32 8.32 0 0 0-6.765 2.428 14.95 14.95 0 0 0-2.487-7.67.48.48 0 0 0-.771 0 14.95 14.95 0 0 0-2.487 7.67 8.32 8.32 0 0 0-6.765-2.428.48.48 0 0 0-.449.455C.688 8.271.587 13.365 6.753 15.01l-2.372 1.355a.479.479 0 0 0 .14.885c1.387.289 3.3 1.247 5.982-.292m0 4.042v-4.042"
  })));
};
export default SvgSeasonAutumn;